export default __webpack_public_path__ + "static/media/90214997-3760-4b80-a23b-fec02ab55fac.c909f47b.woff";